import React from 'react';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import styles from './AddressInformations.module.sass';

const AddressInformations = ({ student, onStudentChange }) => {
  return (
    <Card className={styles.card} title="Adresse du représentant légal" classTitle="title-green">

      <div className={styles.group}>
        <TextInput
          className={styles.field}
          label="Adresse"
          name="legal_guardian_address"
          type="text"
          placeholder="123 rue de l'exemple"
          value={student?.legal_guardian_address || ''}
          onChange={onStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Complément d'adresse"
          name="legal_guardian_address_complement"
          type="text"
          placeholder="Appartement, étage..."
          value={student?.legal_guardian_address_complement || ''}
          onChange={onStudentChange}
        />

        <TextInput
          className={styles.field}
          label="Code Postal"
          name="legal_guardian_zip_code"
          type="text"
          placeholder="75001"
          value={student?.legal_guardian_zip_code || ''}
          onChange={onStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Ville"
          name="legal_guardian_city"
          type="text"
          placeholder="Paris"
          value={student?.legal_guardian_city || ''}
          onChange={onStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Pays"
          name="legal_guardian_country"
          type="text"
          placeholder="France"
          value={student?.legal_guardian_country || ''}
          onChange={onStudentChange}
        />
      </div>
    </Card >
  );
};

export default AddressInformations;
